package com.hyperether.goodjob.scenes.contacts

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Divider
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.navigation.NavHostController
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.Sp
import com.hyperether.goodjob.models.Contact
import com.hyperether.goodjob.models.ContactType
import com.hyperether.goodjob.navigation.*
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.about
import com.hyperether.goodjob.resources.add_new
import com.hyperether.goodjob.resources.address
import com.hyperether.goodjob.resources.back_arrow
import com.hyperether.goodjob.resources.contact_name
import com.hyperether.goodjob.resources.contact_person
import com.hyperether.goodjob.resources.contact_type
import com.hyperether.goodjob.resources.contact_type_contractor
import com.hyperether.goodjob.resources.contact_type_customer
import com.hyperether.goodjob.resources.contact_type_supplier
import com.hyperether.goodjob.resources.edit
import com.hyperether.goodjob.resources.email
import com.hyperether.goodjob.resources.industry
import com.hyperether.goodjob.resources.jobs
import com.hyperether.goodjob.resources.phone
import com.hyperether.goodjob.resources.sites
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.contacts.components.SitesList
import com.hyperether.goodjob.scenes.jobs.components.JobsItem
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.ContactDetailsText
import com.hyperether.goodjob.theme.EmployeeDetailsText
import com.hyperether.goodjob.util.Constants.DEFAULT_JOB_ID
import com.hyperether.goodjob.util.Constants.DEFAULT_SITE_ID
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource
import org.lighthousegames.logging.logging

@Composable
fun ContactDetails(
    contactId: String,
    navHostController: NavHostController,
    viewModel: ContactsViewModel,
    isMobileView: Boolean,
) {
    viewModel.contactTypeMap = mapOf(
        stringResource(Res.string.contact_type_customer) to ContactType.customer.name,
        stringResource(Res.string.contact_type_supplier) to ContactType.supplier.name,
        stringResource(Res.string.contact_type_contractor) to ContactType.contractor.name
    )

    val log = logging("ContactDetails")
    val isAboutContactView = remember { mutableStateOf(true) }
    val isFilesView = remember { mutableStateOf(false) }
    val isSitesContactView = remember { mutableStateOf(false) }
    val isJobsContactView = remember { mutableStateOf(false) }
    val contactsMap = remember { mutableStateMapOf<String, Contact>() }
    val contact by viewModel.contact.collectAsState()

    val jobs by viewModel.jobs.collectAsState()

    LaunchedEffect(contactId) {
        viewModel.loadRemoteData()
        viewModel.fetchContactById(contactId)
    }
    LaunchedEffect(contact) {
        viewModel.getSitesForContactRemote(contactId)
        viewModel.fetchJobsByParentId(contactId)
        viewModel.getSitesForContact(contactId)
        log.d("LaunchedEffect") { "contactId: $contactId details: $contact" }

        // TODO: check this, does not execute
        jobs.forEach { job ->
            job.contactParentId?.let {
                val c = viewModel.getContactById(it)
                c?.id?.let { id ->
                    contactsMap[id] = c
                }
            }
        }
    }

    println(jobs.toList().toString())

    if (isMobileView) {
        Box(modifier = Modifier.fillMaxSize()) {
            Column {
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(Dp(72f))
                        .padding(horizontal = Dp(16f)),
                    contentAlignment = Alignment.Center
                ) {
                    Row(
                        modifier = Modifier.align(Alignment.CenterStart),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Image(
                            painter = painterResource(Res.drawable.back_arrow),
                            contentDescription = "",
                            modifier = Modifier.clickable { navHostController.navigateUp() }
                        )
                    }

                    Text(
                        text = contact?.name ?: "",
                        fontSize = Sp(18f),
                        color = Color.Black,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        textAlign = TextAlign.Center,
                        modifier = Modifier
                            .align(Alignment.Center)
                            .padding(horizontal = Dp(85f))
                    )


                    Row(
                        modifier = Modifier.align(Alignment.CenterEnd),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        when {
                            isSitesContactView.value -> {
                                Row(
                                    horizontalArrangement = Arrangement.End,
                                    verticalAlignment = Alignment.CenterVertically,
                                    modifier = Modifier
                                        .background(
                                            color = BlueApp,
                                            shape = RoundedCornerShape(Dp(32f))
                                        )
                                        .padding(horizontal = Dp(12f), vertical = Dp(10f))
                                ) {
                                    Text(
                                        text = stringResource(Res.string.add_new),
                                        color = Color.White,
                                        fontSize = Sp(14f),
                                        fontWeight = FontWeight.W400,
                                        modifier = Modifier.clickable {
                                            navHostController.navigate(
                                                AddNewSite(
                                                    contactId,
                                                    DEFAULT_SITE_ID
                                                )
                                            )
                                        },
                                        maxLines = 1,
                                        overflow = TextOverflow.Ellipsis
                                    )
                                }
                            }

                            isAboutContactView.value -> {
                                Image(
                                    painter = painterResource(Res.drawable.edit),
                                    contentDescription = "",
                                    modifier = Modifier.clickable {
                                        navHostController.navigate(AddNewContact(contactId))
                                    }
                                )
                            }

                            isJobsContactView.value -> {
                                Row(
                                    horizontalArrangement = Arrangement.End,
                                    verticalAlignment = Alignment.CenterVertically,
                                    modifier = Modifier
                                        .background(
                                            color = BlueApp,
                                            shape = RoundedCornerShape(Dp(32f))
                                        )
                                        .padding(horizontal = Dp(12f), vertical = Dp(10f))
                                ) {
                                    Text(
                                        text = stringResource(Res.string.add_new),
                                        color = Color.White,
                                        fontSize = Sp(14f),
                                        fontWeight = FontWeight.W400,
                                        modifier = Modifier.clickable {
                                            navHostController.navigate(AddNewJob(DEFAULT_JOB_ID))
                                        },
                                        maxLines = 1,
                                        overflow = TextOverflow.Ellipsis
                                    )
                                }
                            }
                        }
                    }
                }
                Divider(
                    modifier = Modifier.height(Dp(2f))
                        .background(Color.LightGray.copy(alpha = 0.1f))
                )
                Column(
                    modifier = Modifier.background(Color.LightGray.copy(alpha = 0.2f))
                        .padding(Dp(8f)), horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth().height(Dp(40f)),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Box(
                            modifier = Modifier
                                .weight(0.33f)
                                .fillMaxSize()
                                .clickable(
                                    interactionSource = remember { MutableInteractionSource() },
                                    indication = null
                                ) {
                                    isAboutContactView.value = true
                                    isFilesView.value = false
                                    isSitesContactView.value = false
                                    isJobsContactView.value = false
                                },
                            contentAlignment = Alignment.Center
                        ) {
                            androidx.compose.material3.Text(
                                text = stringResource(Res.string.about),
                                color = if (isAboutContactView.value) BlueApp else Color.Gray,
                                fontWeight = if (isAboutContactView.value) FontWeight.Bold else FontWeight.Normal,
                                fontSize = Sp(16f),
                                textAlign = TextAlign.Center,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }

//                    androidx.compose.material3.Text(
//                        text = stringResource(Res.string.files_notes),
//                        color = if (isFilesView.value) BlueApp else Color.Gray,
//                        fontWeight = if (isFilesView.value) FontWeight.Bold else FontWeight.Normal,
//                        fontSize = Sp(16f),
//                        modifier = Modifier
//                            .padding(end = Dp(20f))
//                            .clickable {
//                                isAboutContactView.value = false
//                                isFilesView.value = true
//                                isSitesContactView.value = false
//                                isJobsContactView.value = false
//                            }
//                    )
//                    Spacer(modifier = Modifier.weight(0.5f))

                        Box(
                            modifier = Modifier
                                .weight(0.33f)
                                .fillMaxSize()
                                .clickable(
                                    interactionSource = remember { MutableInteractionSource() },
                                    indication = null
                                ) {
                                    isAboutContactView.value = false
                                    isFilesView.value = false
                                    isSitesContactView.value = true
                                    isJobsContactView.value = false
                                },
                            contentAlignment = Alignment.Center
                        ) {
                            androidx.compose.material3.Text(
                                text = stringResource(Res.string.sites),
                                color = if (isSitesContactView.value) BlueApp else Color.Gray,
                                fontWeight = if (isSitesContactView.value) FontWeight.Bold else FontWeight.Normal,
                                fontSize = Sp(16f),
                                textAlign = TextAlign.Center,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }

                        Box(
                            modifier = Modifier
                                .weight(0.33f)
                                .fillMaxSize()
                                .clickable(
                                    interactionSource = remember { MutableInteractionSource() },
                                    indication = null
                                ) {
                                    isAboutContactView.value = false
                                    isFilesView.value = false
                                    isSitesContactView.value = false
                                    isJobsContactView.value = true
                                },
                            contentAlignment = Alignment.Center
                        ) {
                            androidx.compose.material3.Text(
                                text = stringResource(Res.string.jobs),
                                color = if (isJobsContactView.value) BlueApp else Color.Gray,
                                fontWeight = if (isJobsContactView.value) FontWeight.Bold else FontWeight.Normal,
                                fontSize = Sp(16f),
                                textAlign = TextAlign.Center,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    }
                }
                Row(
                    modifier = Modifier.fillMaxWidth().height(Dp(2f)),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    if (isAboutContactView.value) {
                        Box(
                            modifier = Modifier.height(Dp(2f)).weight(0.33f).fillMaxWidth(0.5f)
                                .background(BlueApp).padding()
                        )
                    }
                    Spacer(modifier = Modifier.weight(0.33f))
//                if (isFilesView.value) {
//                    Box(
//                        modifier = Modifier
//                            .height(Dp(2f))
//                            .width(120Dp())
//                            .padding(start = Dp(10f))
//                            .fillMaxWidth(0.5f)
//                            .background(BlueApp)
//                    )
//                }
//                Spacer(modifier = Modifier.weight(0.41f))
                    if (isSitesContactView.value) {
                        Box(
                            modifier = Modifier.height(Dp(2f)).weight(0.33f)
                                //.padding(start = Dp(10f))
                                .fillMaxWidth(0.5f).background(BlueApp)
                        )
                    }
                    Spacer(modifier = Modifier.weight(0.33f))
                    if (isJobsContactView.value) {
                        Box(
                            modifier = Modifier.height(Dp(2f)).weight(0.33f).fillMaxWidth(0.5f)
                                .background(BlueApp)
                        )
                    }
                }
                if (isAboutContactView.value) {
                    Spacer(modifier = Modifier.height(Dp(15f)))
                    Column(
                        modifier = Modifier
                            .verticalScroll(rememberScrollState())
                            .disableMouseDragScrollOnWeb()
                    ) {
                        DetailsTextItem(
                            stringResource(Res.string.contact_name), contact?.name ?: ""
                        )
                        if (contact?.contactType?.isNotEmpty() == true) DetailsTextItem(
                            stringResource(Res.string.contact_type),
                            viewModel.contactTypeMap.entries.find { item -> item.value == contact?.contactType }?.key
                                ?: ""
                        )
                        if (contact?.industry?.isNotEmpty() == true) DetailsTextItem(
                            stringResource(Res.string.industry), contact?.industry ?: ""
                        )
                        val address = contact?.addressObject?.address ?: ""
                        val zip = contact?.addressObject?.zip ?: ""
                        val country = contact?.addressObject?.country ?: ""
                        if (address.isNotEmpty() || zip.isNotEmpty() || country.isNotEmpty()) DetailsTextItem(
                            stringResource(Res.string.address),
                            "${address}, $zip $country",
                            BlueApp
                        )
                        if (contact?.phone?.isNotEmpty() == true) DetailsTextItem(
                            stringResource(Res.string.phone), contact?.phone ?: ""
                        )
                        if (contact?.email?.isNotEmpty() == true) DetailsTextItem(
                            stringResource(Res.string.email).replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() },
                            contact?.email ?: ""
                        )
                        Spacer(modifier = Modifier.height(Dp(16f)))
                        Text(
                            text = stringResource(Res.string.contact_person),
                            fontSize = Sp(18f),
                            color = Color.Black,
                            fontWeight = FontWeight.Bold,
                            modifier = Modifier.padding(start = Dp(16f))
                        )
                        if (contact?.personName?.isNotEmpty() == true) {
                            Spacer(modifier = Modifier.height(Dp(15f)))
                            DetailsTextItem(
                                stringResource(Res.string.contact_person), contact?.personName ?: ""
                            )
                        }
                        if (contact?.personPhone?.isNotEmpty() == true) {
                            Spacer(modifier = Modifier.height(Dp(10f)))
                            DetailsTextItem(
                                stringResource(Res.string.phone), contact?.personPhone ?: ""
                            )
                        }
                        if (contact?.personEmail?.isNotEmpty() == true) DetailsTextItem(
                            stringResource(Res.string.email).replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() },
                            contact?.personEmail ?: ""
                        )
                    }
                }
                if (isFilesView.value) {
                    Spacer(modifier = Modifier.height(Dp(15f)))
                }
                if (isSitesContactView.value) {
                    Spacer(modifier = Modifier.height(Dp(15f)))
                    SitesList(viewModel.currentSitesForContact, onEditSiteClick = { siteId ->
                        siteId?.let {
                            navHostController.navigate(AddNewSite(contactId, it))
                        }
                    })
                }
                if (isJobsContactView.value) {
                    LazyColumn(
                        modifier = Modifier.fillMaxSize().padding(start = Dp(8f), end = Dp(16f))
                    ) {
                        if (jobs.isNotEmpty()) {
                            val jobsSorted = viewModel.sortJobs(jobs)
                            jobsSorted.forEach { (date, jobsForDate) ->
                                items(jobsForDate.takeIf { it.isNotEmpty() }
                                    ?: emptyList()) { job ->
                                    JobsItem(
                                        viewModel.sitesMap[job.contactSiteId],
                                        job = job,
                                        selectedJobs = mutableListOf(),
                                        isInEditMode = false,
                                        onJobSelected = { job, isSelected -> },
                                        onItemClick = {
                                            job.id?.let { navHostController.navigate(JobDetails(it)) }
                                        })
                                }
                            }
                        }
                    }
                }
            }
        }
    } else {
        SelectionContainer {
            ContactDetailsWeb(navHostController, viewModel, contactId)
        }
    }
}

@Composable
fun DetailsTextItem(header: String, detailsText: String, color: Color = ContactDetailsText) {
    Column {
        Text(
            text = header,
            color = EmployeeDetailsText,
            fontWeight = FontWeight.W400,
            fontSize = Sp(14f),
            modifier = Modifier.padding(start = Dp(16f), end = Dp(16f))

        )
        Text(
            text = detailsText,
            color = color,
            fontWeight = FontWeight.W500,
            fontSize = Sp(14f),
            modifier = Modifier.padding(start = Dp(16f), end = Dp(16f))
        )
        Spacer(modifier = Modifier.height(Dp(12f)))
    }
}
